import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useSnackbar } from "./useSnackbar";  // Ensure correct import

const CustomAlert = React.forwardRef((props, ref) => (
  <MuiAlert ref={ref} elevation={6} variant="filled" {...props} style={{ whiteSpace: "nowrap" }} />
));

export const Toaster = () => {
  const { snackbar } = useSnackbar();  // Use the hook here

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={snackbar.open}
      autoHideDuration={4000}
      style={{
        borderRadius: "6px",
        zIndex: 9999,
        position: "fixed",
        top: "66px",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <CustomAlert
        elevation={6}
        variant="filled"
        severity="success"
        sx={{ backgroundColor: "#1C6347", color: "#fff" }}
        icon={<FontAwesomeIcon icon={faCircleCheck} />}
      >
        {snackbar.message}
      </CustomAlert>
    </Snackbar>
  );
};

export default Toaster;
